import { render, staticRenderFns } from "./CTtable.vue?vue&type=template&id=2c06548a&scoped=true"
import script from "./CTtable.vue?vue&type=script&lang=js"
export * from "./CTtable.vue?vue&type=script&lang=js"
import style0 from "./CTtable.vue?vue&type=style&index=0&id=2c06548a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06548a",
  null
  
)

export default component.exports